// eslint-disable-next-line eslint-comments/disable-enable-pair
/* eslint-disable formatjs/no-literal-string-in-jsx */
import { Button, Card, Typography } from "@carrotfertility/carotene-core"
import React from "react"

export function SidebarCard(): JSX.Element {
  return (
    <Card
      color="green"
      variant="secondary"
      title="Other ways to contact Carrot"
      primaryAction={
        <Button variant="outlined" color="secondary">
          Call us
        </Button>
      }
    >
      <Typography variant="h6">Call us</Typography>
      <Typography>Need help now? Talk to one of our Carrot Companions at +1 888-817-9040</Typography>
    </Card>
  )
}
